<template>
    <div>

        <!--                头部-->
        <!--        <div class="w"></div>-->
        <header>

            <div class="logo">
                <img class="logo-img" src="../../../public/logo1.png" alt="example">
                <div class="logo_font">SARAY</div>


            </div>
            <div class="menu">
                <MenuConponents :menu="menu" :path="path"></MenuConponents>


            </div>
            <div class="login">
                <transition name="el-zoom-in-center" mode="out-in">
                    <button @click="show_login" v-if="!username" class="login_bu">登录</button>

                    <div class="avatar_box" v-else>
                        <span class="name">{{username}}</span>
                        <img class="avatar_img" :src="avatar?avatar:'../../../public/avatar.jpeg'" alt="avatar"/>
                        <div class="out_img" @click="out_login"></div>

                    </div>
                </transition>


            </div>


        </header>
        <LoginPage :show="show_modal" @confirm="login" @close="close" :loading="loading"></LoginPage>


    </div>
</template>

<script>
    import LoginPage from "@/view/Login/LoginPage";
    import md5 from 'js-md5'
    // import loadingRoute from "@/utils/loadingRoute";
    import MenuConponents from "./MenuConponents"


    export default {
        name: "IndexPage",

        components: {
            LoginPage,
            MenuConponents

        },
        data() {
            return {
                show: true,
                show_modal: false,
                loading: false
            };
        },
        created() {


        },
        computed: {
            menu() {
                let route = this.$store.state.user.route
                const lis = []
                route.forEach(item => {
                    if (!item.hidden) {
                        lis.push(item)
                    }

                })
                return lis
            },
            path() {
                return this.$route.path
            },
            username() {

                return this.$store.getters.username ? this.$store.getters.username : ''
            },
            avatar() {
                return this.$store.getters.avatar ? this.$store.getters.avatar : ''
            }

        },
        methods: {
            //管模态框
            close() {
                this.show_modal = false
                this.loading = false
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            },
            //显示模态框按钮
            show_login() {

                this.show_modal = true

            },
            //退出登录
            out_login() {
                this.$confirm('退出操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await this.$store.dispatch('user/logout')
                    this.$router.push({path: '/'})

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消退出'
                    });
                });

            },
            //登录
            login(e) {
                this.loading = true
                let data = {...e}
                data.password = md5(e.password)

                this.$store.dispatch('user/login', data).then(res => {
                    if (res.code === 200) {

                        this.loading = false
                        this.show_modal = false
                        this.$router.push({path: '/work'})
                        localStorage.setItem('key', JSON.stringify(e));

                    }

                }).catch(() => {
                    this.loading = false
                })


            },
        }
    }
</script>

<style scoped>


    header {
        /*display: flex;*/
        /*background-color: #111;*/
        position: fixed;
        display: flex;
        justify-content: space-between;
        background: #1C202B;
        /*justify-content: space-between;*/
        top: 0;
        left: 0;
        /*z-index: 99999;*/
        width: 100%;
        height: 80px;
    }

    .job_box {
        /*width: 100%;*/
        display: flex;
        justify-content: space-between;
        background: #1C202B;
    }


    .logo {
        /*width: 25%;*/
        background: #1C202B;
        display: flex;
        justify-content: space-between;
    }

    .logo_font {
        display: flex;
        align-self: center;
        color: #CAB899;
        font-family: Georgia;
        font-weight: 800;
        font-size: 28px;
        letter-spacing: 15px;
        text-shadow: 5px 6px 5px #9DA586;
    }

    .logo-img {
        width: 100px;
        height: 100px;
        box-shadow: 0px 15px 25px 2px rgba(0, 0, 0, 0.3),
        25px 20px 20px 3px rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        align-self: center;
        /*padding-left: 20px;*/


    }

    .menu {
        background: #1C202B;
        /*width: 65%;*/
        display: flex;
        /*padding: 35px;*/
        justify-content: center;
        /*border: 2px dotted red;*/
        /*border-left-color:  #666;*/

    }

    /*.job {*/
    /*    width: 10%;*/
    /*    background: #1C202B;;*/
    /*}*/

    .login {
        /*width: 10%;*/
        background: #1C202B;;
        display: flex;
        justify-content: center;
    }

    .btn {
        font-size: 19px;
        width: 95px;
        height: 85px;
        align-self: center;
        /*padding: 0.8rem 1.6rem;*/
        background-color: #1C202B;
        /*padding-right: 7px;*/
        color: #87AD0B;
        border: none;
        cursor: pointer;
        box-shadow: 15px 15px 15px 15px rgba(255, 255, 255, 0.3), 15px 15px 15px 15px rgba(255, 255, 255, 0.3);
        transition: box-shadow 0.3s ease-in-out;
    }

    .btn:hover,
    .btn:focus {
        outline: none;
        box-shadow: 0px 0px 0px 5px rgba(0, 0, 0, 0.3);
    }

    .login_bu {
        align-self: center;
        background: #1C202B;
        color: #87AD0B;
        font-size: 19px;
        width: 95px;
        margin-right: 10px;
        border-radius: 15px;


    }

    .login_bu:hover,
    .login_bu:focus {
        color: #37A047;
        background-color: #3C3C4D;

    }

    .avatar_box {
        align-self: center;
        display: flex;
        justify-content: space-around;
    }

    .avatar_img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
    }

    .out_img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
        border-radius: 50%;
        background-image: url("../../../public/out1.png");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        box-shadow: 0px 5px 20px rgba(72, 76, 88, 0.5);
        transition: transform 0.2s ease-in-out;

    }

    .out_img:hover,
    .out_img:focus {


        background-image: url("../../../public/out2.png");


        /*transform: scale(1.02);*/
        /*box-shadow: 0px 10px 30px rgba(255, 255, 255, 0.5);*/

    }

    .out_img:active {
        background-color: #3C3C4D;
        background-image: url("../../../public/out1.png");


    }

    .name {
        align-self: self-end;
        color: #9EABCF;
        font-size: 18px;
        font-weight: bold;
        padding-right: 5px;
    }


</style>
